import styled from 'styled-components';

// título de coluna com explicação ao passar o mouse
export const ColumnHint = styled.span`
    cursor: help;
    border-bottom: 1px dotted currentColor;
`

// segunda linha de uma célula da lista (ex.: "desde dd/mm/aaaa hh:mm")
export const CellDetail = styled.div`
    font-size: 12px;
    color: #9a9da0;
`
